import { styled } from '@mui/material/styles';
import { Link as ReactLink } from 'react-router-dom';

export const ListItem = styled('li')({
    display: 'flex',
    alignItems: 'center',
    paddingRight: '16px',
});

export const Link = styled(ReactLink)({
    display: 'inline-flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: 'black',
    '&:hover': {
        color: 'gray',
    },
});